import firebase from 'firebase'
import { fileURLToPath } from 'url';

const config = {
    apiKey: "AIzaSyAB_9JbbxGVgmuPOnE6vf2wEPOYMVuGhbE",
    authDomain: "abilitaxr-live.firebaseapp.com",
    databaseURL: "https://abilitaxr-live.firebaseio.com",
    projectId: "abilitaxr-live",
    storageBucket: "abilitaxr-live.appspot.com",
    messagingSenderId: "794946610357"
  };
  /*
const config = {
    apiKey: "AIzaSyCcSmVw273OyGvNKb9b0vCE8l5sE9vgjJ0",
    authDomain: "abilitaxr-stage.firebaseapp.com",
    databaseURL: "https://abilitaxr-stage.firebaseio.com",
    projectId: "abilitaxr-stage",
    storageBucket: "abilitaxr-stage.appspot.com",
    messagingSenderId: "962024408855",
    appId: "1:962024408855:web:9dbead888f223f4e"
  };*/
firebase.initializeApp(config);
export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js